import React, { useState } from 'react'
import { Badge } from 'reactstrap'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ChevronRight from '../../../svgs/ChevronRight'
import history from '../../../helpers/History'

const ImportStatus = ({
  importStats = null,
  isAdmin = false,
  projectId,
  state
}) => {
  const { t } = useTranslation('ProjectsPage')
  const [isHovered, setIsHovered] = useState(false)

  const badgeColorFromState = () => {
    switch (state) {
      case 'pending': return 'warning'
      case 'importing': return 'primary'
      case 'importing_succeeded': return 'success'
      case 'importing_failed': return 'danger'
      default: return 'secondary'
    }
  }

  const lastImportTime = () => {
    if (!importStats?.end) return null
    return moment(importStats.end).fromNow()
  }

  const handleClick = () => {
    history.push(`/projects/${projectId}/imports`)
  }

  const timeAgo = lastImportTime()

  const className = [
    'd-flex justify-content-between align-items-center',
    isAdmin && isHovered ? 'import-status-row-hover' : ''
  ].filter(Boolean).join(' ')

  const baseStyle = {
    marginLeft: '-1rem',
    marginRight: '-1rem',
    padding: '0.5rem 1rem'
  }

  const adminStyle = {
    ...baseStyle,
    cursor: 'pointer',
    transition: 'background-color 0.15s ease-in-out'
  }

  if (!isAdmin) {
    return (
      <div className={className} style={baseStyle}>
        <div className="d-flex flex-column">
          <small className="text-muted fw-bold">
            {t('ProjectCard.ImportStatus.label')}
          </small>
          {timeAgo && (
            <small className="text-muted" style={{ fontSize: '0.7rem' }}>
              {timeAgo}
            </small>
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          <Badge color={badgeColorFromState()}>
            {t(`ProjectCard.ImportStatus.shortStates.${state}`)}
          </Badge>
        </div>
      </div>
    )
  }

  return (
    <div
      className={className}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      role="button"
      style={adminStyle}
      tabIndex={0}
    >
      <div className="d-flex flex-column">
        <small className="text-muted fw-bold">
          {t('ProjectCard.ImportStatus.label')}
        </small>
        {timeAgo && (
          <small className="text-muted" style={{ fontSize: '0.7rem' }}>
            {timeAgo}
          </small>
        )}
      </div>
      <div className="d-flex align-items-center gap-2">
        <Badge color={badgeColorFromState()}>
          {t(`ProjectCard.ImportStatus.shortStates.${state}`)}
        </Badge>
        <ChevronRight className="text-muted" size={0.8} />
      </div>
    </div>
  )
}

ImportStatus.propTypes = {
  importStats: PropTypes.shape({
    duration: PropTypes.number,
    end: PropTypes.string
  }),
  isAdmin: PropTypes.bool,
  projectId: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired
}

export default ImportStatus
